var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card",on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.$slots.header)?_c('header',[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"body"},[_vm._t("default")],2),(_vm.$slots.footer)?_c('footer',[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }